import apiClient from './api/apiClient';
import { ENDPOINTS } from './api/endpoints';

export const assistantService = {
  chat: async ({ message, context = "general", language = "en", platform = "signality" }) => {
    return apiClient.post(ENDPOINTS.ASSISTANT.CHAT, { message, context, language, platform });
  },
};

export default assistantService;
